















































import Vue from 'vue';
import { Arrangement } from '../domain/Arrangement';
import { ArrangementOption } from '../domain/ArrangementOption';
import Pricing from '../../../../../frontend/components/Pricing.vue';
import { hideDiscounts, hideSalesOnDeals } from '../../../../../frontend/helper/formula';

export default Vue.extend({
  name: 'DealArrangement',
  components: { Pricing },
  props: {
    arrangement: {
      type: [Arrangement as any, ArrangementOption as any],
      required: true,
    },
    isDisplayTypeTitle: {
      type: Boolean,
      default: false,
    },
    isActive: {
      type: Boolean,
      default: false,
    },
    showPromoCode: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    showDiscount(): boolean {
      return (
        !!(this.arrangement as any).stats.discount && !this.isDisplayTypeTitle && !hideDiscounts()
      );
    },
    showSales(): boolean {
      return !hideSalesOnDeals();
    },
  },
});
